import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  name: 'record_points_acquisition',
  props: {
    value: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          console.log(val);
          this.params.consumerOpenId = val.consumerOpenId;
          this.params.consumerPhone = val.consumerPhone;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      requestType: 'POST',
      isCalculateHeight: false,
      params: {
      },
    };
  },
  created() {
    this.getConfigList('record_points_acquisition');
  },

  methods: {
  },
};
